import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import styled from 'styled-components';
import { avatarData } from '../data/avatarData';

const ButtonHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 4rem 0;
  > * {
    margin-bottom: 2rem;
  }
`;

class Home extends Component {

  state = {
    redirect: false,
  };

  clickHandler = () => {
    this.props.dispatch( {
      type: 'CLEAR_PARTICIPANT',
    } );
    this.props.dispatch( {
      type: 'CLEAR_ATTRIBUTES',
      avatar: 1
    } );
    this.props.dispatch( {
      type: 'CLEAR_IDS',
    } );
    this.setState( {
      redirect: true,
    } );
  };

  render() {
    if ( this.state.redirect ) {
      return <Redirect push to="/how-does-it-work"/>;
    } else {
      return (
        <main>
          <h1>Welcome to the Automatic Avatar Generator for Virtual Reality</h1>

          <p>The automatic avatar generation for VR is a feature that, through AI and ML, converts a photo of people into their avatars.</p>

          <p>As you will see, AI can be trained to read photos with the use of labels. In this exercise we will ask you to help us build this ML system by doing this labeling. In the process you will learn about label bias.</p>

          <ButtonHolder>
          <h3>Can you help us?</h3>
          <button className="primary" onClick={this.clickHandler}>Yes, I can!</button>
          <Link className="button" to={`/${avatarData[0].name}-gallery`}>View avatar gallery</Link>
          </ButtonHolder>
        </main>
      )
    }
  }
}

function mapStateToProps( state ) {
  return {
    avatar: state.avatar,
  };
}

export default connect( mapStateToProps )( Home );
